import { useResource } from 'json-api-hooks';

export const useCurrentActor = () => {
  const { attributes, id } = useResource({ id: '', type: 'sessions' })[0] ?? {
    attributes: {
      centerLat: 0,
      centerLon: 0,
      actorType: 'ConfirmedUser',
      userId: '0',
      postalRanges: [],
      postalDigits: 0,
      maxPriority: 0,
      minPriority: 0,
      zoom: 0,
      firstName: '',
      doorsCount: 0,
      activeDaysCount: 0,
      nextDoorsTarget: 0,
      organizer: false,
      admin: false,
      multipleManagedDepartments: false,
      volunteersCount: 0,
      newVolunteersCount: 0,
      futureEventsCount: 0,
      activeVolunteersCount: 0,
    },
  };

  return { id, ...attributes };
};
